import { SearchPlayerStep } from './steps/SearchPlayerStep';
import { DepositAmountStep } from './steps/DepositAmountStep';
import { PlayerConfirmation } from './steps/playerConfirmation';
import { DepositSuccess } from './steps/depositSuccess';

const searchPlayerStep = {
  component: SearchPlayerStep,
  validate: (form) => {
    const formErrors = {};

    if (form.searchType === 'playerId') {
      if (!form.playerId && form.playerId !== 0) {
        formErrors.playerId = 'Field is required';
      } else if (form.playerId && isNaN(Number(form.playerId))) {
        formErrors.playerId = 'Player ID must be a number';
      }
    }

    if (form.searchType === 'username' && !form.playerName) {
      formErrors.playerName = 'Field is required';
    }

    return formErrors;
  },
};

const playerConfirmationStep = {
  component: PlayerConfirmation,
  validate: (form) => {
    const formErrors = {};
    return formErrors;
  },
};

const depositAmountStep = {
  component: DepositAmountStep,
  validate: (form) => {
    const formErrors = {};

    if (!form.amount) {
      formErrors.amount = 'Amount is required';
    }

    if (form.amount && form.amount <= 0) {
      formErrors.amount = 'Amount must be greater than 0';
    }

    if (form.maxDepositAmount && form.amount > form.maxDepositAmount) {
      formErrors.amount = `Amount cannot exceed ${form.maxDepositAmount}`;
    }

    return formErrors;
  },
};

const depositSuccessStep = {
  component: DepositSuccess,
  validate: () => ({}),
};

const stepMap = {
  search_player: searchPlayerStep,
  deposit_amount: depositAmountStep,
  client_deposit_player_confirmation: playerConfirmationStep,
  deposit_success: depositSuccessStep,
};

export const getStepsList = () => [
  { name: 'search_player', step: stepMap.search_player },
  { name: 'client_deposit_player_confirmation', step: stepMap.client_deposit_player_confirmation },
  { name: 'deposit_amount', step: stepMap.deposit_amount },
  { name: 'deposit_success', step: stepMap.deposit_success },
];
